import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { useEffect } from 'react';
import { useCorporateAccountEstablishStore } from '../hooks';
import { ErrorWord, TemplateProps, yupNumberString } from '../common';
import { formErrorScroll } from 'views/mutual/formErrorScroll';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';


export type InvoiceType = {
  invoiceNumber: string;
  hasNoInvoiceNumber: boolean;
};

export const useInvoice = ({ isUpdate }: TemplateProps) => {
  const { param, add } = useCorporateAccountEstablishStore();
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();
  const { messageClose } = useGlobalToastHandler();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validation = Yup.object().shape({    
    invoiceNumber: Yup.string().when('hasNoInvoiceNumber', {
      is: false,
      then: () => yupNumberString({
        length: 13,
        isRequired: false,
        errorWord: ErrorWord.INVOICE_NUMBER,
      }),
      otherwise: (schema) => schema.strip(), 
    }),
  });

  const initialValues: InvoiceType = {
    invoiceNumber: param.invoiceNumber ?? '',
    hasNoInvoiceNumber: param.hasNoInvoiceNumber ?? false,
  };

  const formik = useFormik<InvoiceType>({
    enableReinitialize: isUpdate,
    initialValues,
    async onSubmit() {
      add({
        ...param,
        ...formik.values,
      });
      setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.entryConfirm);
    },
    validationSchema: validation,
    validateOnChange: false,
    validateOnBlur: false,
    validate: () => {
      // バリデーションかける時に必ずエラートーストを閉じる
      messageClose();
    },
  });

  const invoiceNumberProps = {
    textInput : {
      value: formik.values.invoiceNumber,
      onChange: (value: string) => formik.setFieldValue('invoiceNumber', value),
      disabled : formik.values.hasNoInvoiceNumber,
      error: formik.errors.invoiceNumber,
    },
    checkInput : {
      checked: formik.values.hasNoInvoiceNumber,
      setChecked: (value: boolean) => {
        formik.setFieldValue('hasNoInvoiceNumber', value);
        if(value){
          formik.setFieldValue('invoiceNumber', '');
        }
      },
      error: formik.errors.hasNoInvoiceNumber,
    },
  };

  useEffect(() => {
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    invoiceNumberProps,
  };
};
